function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.34103 11.6456L7.9995 8.98714L10.658 11.6456C10.7791 11.7667 11.2062 11.8649 11.535 11.536C11.8639 11.2071 11.7658 10.7801 11.6447 10.659L8.98616 8.00046L11.6446 5.34197C11.7657 5.2209 11.8639 4.79384 11.535 4.46497C11.2062 4.1361 10.7791 4.23424 10.658 4.35533L7.9995 7.01383L5.34099 4.35532C5.21991 4.23425 4.79285 4.13606 4.46395 4.46495C4.13506 4.79385 4.23325 5.22091 4.35432 5.34199L7.01283 8.0005L4.35433 10.659C4.23326 10.7801 4.13507 11.2071 4.46397 11.536C4.79287 11.8649 5.21994 11.7667 5.34103 11.6456Z",
  fill: "#FE3745"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.7c26d6ed.svg";
export { ForwardRef as ReactComponent };